// extracted by mini-css-extract-plugin
export default {"mobileBottomBar":"MobileBottomBar_mobileBottomBar__mx15T","active":"MobileBottomBar_active__8Mj1h","count":"MobileBottomBar_count__clJhf"};